import { render, staticRenderFns } from "./PositionSelect.vue?vue&type=template&id=0df3735e&scoped=true&"
import script from "./PositionSelect.vue?vue&type=script&lang=js&"
export * from "./PositionSelect.vue?vue&type=script&lang=js&"
import style0 from "./PositionSelect.vue?vue&type=style&index=0&id=0df3735e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df3735e",
  null
  
)

export default component.exports